import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0653a62d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-creation-wizard__container" }
const _hoisted_2 = { class: "profile-creation-wizard__content-actions" }
const _hoisted_3 = { class: "profile-creation-wizard__content" }
const _hoisted_4 = { class: "details-form__item" }
const _hoisted_5 = { class: "details-form__item__title" }
const _hoisted_6 = { class: "custom-font-text" }
const _hoisted_7 = { class: "add-experience" }
const _hoisted_8 = { class: "experiences" }
const _hoisted_9 = { class: "profile-creation-wizard__content-footer" }

import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {StepNavigator} from '@/profile-creation-wizard/common/step/StepNavigator';
    import StepActions from '@/profile-creation-wizard/common/ui/step/StepActions.vue';
    import StepMobileHeader from '@/profile-creation-wizard/common/ui/step/StepMobileHeader.vue';
    import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';
    import {useTranslation} from '@malt/vue3-use';
    // import {ProfileCreationFunnelMode} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
    import {computed, inject, onBeforeMount, ref} from 'vue';
    import {useRouter} from 'vue-router';
    import {Experience} from '../../domain/experience/Experience';
    import ExperienceComponent from './components/Experience.vue';
    import ExperienceForm from './components/ExperienceForm.vue';
    import YourExperienceSide from './YourExperienceSide.vue';

    const stepName = 'completion_experience';

    const isStepOptionnal = true;
    const dataHeapTooltipID = 'profile-creation-tooltip-experience';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'YourExperienceStep',
  setup(__props) {

    const router = useRouter();
    const {msg} = useTranslation();

    const experienceDomainService = inject(DI.experienceDomainService);

    const refExperiences = ref<HTMLElement>();
    const experiences = ref<Experience[]>([]);
    const hasValidFieldPart = ref(false);
    const isVisibleAddExperienceForm = ref(false);
    const meta = computed(() => router.currentRoute.value.meta);
    // const isStepOptionnal = computed(() => meta.value.funnelMode === ProfileCreationFunnelMode.CLASSIC);
    const progressPercentage = computed(() => meta.value.progressPercentage);
    const stepNavigator = new StepNavigator(router, meta.value.previousStep, meta.value.nextStep);

    const bottomSheetDisplayer = ref<BottomSheetDisplayer>(null);

    onBeforeMount(async () => {
        experiences.value = await fetchExperiences();

        bottomSheetDisplayer.value = new BottomSheetDisplayer(
            '#completion-your-experience-bottom-sheet',
            dataHeapTooltipID,
            refExperiences.value,
            'div.profile-creation-wizard',
        );
        bottomSheetDisplayer.value.mounted();
    });

    // Event handlers
    async function handleAddExperience() {
        isVisibleAddExperienceForm.value = true;
    }
    // Event handles: experience-form
    function handleExperienceFormCancel() {
        isVisibleAddExperienceForm.value = false;
    }
    async function handleExperienceFormAdd(experience: Experience) {
        experiences.value.push(experience);
        await updateExperiences();
        isVisibleAddExperienceForm.value = false;
        await fetchExperiences();
    }

    // Fetch experiences
    async function fetchExperiences(): Promise<Experience[] | undefined> {
        try {
            return await experienceDomainService!.fetchExperiences();
        } catch (e) {
            displayTechnicalErrorNotification();
        }
    }
    async function updateExperiences() {
        try {
            await experienceDomainService!.updateExperiences(experiences.value);
        } catch (e) {
            displayTechnicalErrorNotification();
        }
    }

    // StepNavigator action
    function goToPrevious(): void {
        stepNavigator.previous();
    }
    function goNext(): void {
        stepNavigator.next();
    }

    function openBottomSheet(): void {
        bottomSheetDisplayer.value.openBottomSheet();
    }

    function displayTechnicalErrorNotification() {
        pushNotification(msg('profile.creation.common.notification.error.technical'), {level: 'error'});
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_progress_bar = _resolveComponent("joy-progress-bar")!
  const _component_joy_divider_cta = _resolveComponent("joy-divider-cta")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "refExperiences",
    ref: refExperiences,
    class: "profile-creation-wizard ff-bottom-fixed-cta"
  }, [
    _createVNode(_component_joy_progress_bar, { percentage: progressPercentage.value }, null, 8, ["percentage"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(StepMobileHeader, {
            "step-name": stepName,
            "onClick:previous": goToPrevious
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, [
              _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.experience.title')) + " ", 1),
              _createElementVNode("p", _hoisted_6, [
                _createElementVNode("a", {
                  class: "open-bottom-sheet",
                  onClick: openBottomSheet
                }, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.side.experience.title')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (!isVisibleAddExperienceForm.value)
              ? (_openBlock(), _createBlock(_component_joy_divider_cta, {
                  key: 0,
                  onClick: handleAddExperience
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.experience.cta.add')), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(ExperienceForm, {
                  key: 1,
                  "onExperienceForm:cancel": handleExperienceFormCancel,
                  "onExperienceForm:add": handleExperienceFormAdd
                }))
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(experiences.value, (experience) => {
              return (_openBlock(), _createBlock(ExperienceComponent, {
                key: experience.id,
                experience: experience
              }, null, 8, ["experience"]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_joy_progress_bar, {
            percentage: progressPercentage.value,
            mode: "mobile"
          }, null, 8, ["percentage"]),
          _createVNode(StepActions, {
            "step-name": stepName,
            "show-button-previous": true,
            "show-button-skip": isStepOptionnal,
            "is-disabled-button-next": !hasValidFieldPart.value,
            "is-hidden-button-skip": hasValidFieldPart.value,
            "onClick:next": goNext,
            "onClick:skip": goNext,
            "onClick:previous": goToPrevious
          }, null, 8, ["is-disabled-button-next", "is-hidden-button-skip"])
        ])
      ]),
      _createVNode(YourExperienceSide)
    ])
  ], 512))
}
}

})